export const getCross = (fieldValue) => fieldValue?{showClear:true}:{}